import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";

@Injectable({ providedIn: "root" })
export class LanguageService {
  public languages: string[] = ["pt", "en", "es"];

  constructor(
    public translate: TranslateService,
    private cookieService: CookieService,
  ) {}

  init(): Promise<void> {
    this.translate.addLangs(this.languages);
    this.translate.setDefaultLang("pt");

    let lang = "pt";

    if (this.cookieService.check("lang")) {
      lang = this.cookieService.get("lang");
    } else {
      const browserLang = this.translate.getBrowserLang();
      lang = browserLang?.match(/pt|en|es/) ? browserLang : "pt";
      this.cookieService.set("lang", lang);
    }

    return new Promise((resolve) => {
      this.translate.use(lang).subscribe({
        next: () => resolve(),
        error: () => resolve(),
      });
    });
  }

  public setLanguage(lang) {
    this.translate.use(lang);
    this.cookieService.set("lang", lang);
  }
}
